<template>
  <div class="order-detail-wrapper">
    <div class="content-wrapper">
      <div class="left-side">
        <MemberLeft activeIndex="orderlist" />
      </div>
      <div class="right-content">
        <OrderDetailContent>
          <template v-slot:orderCustom="{ orderInfo }">
            <div class="order-custom" v-if="orderInfo">
              <template v-if="orderInfo.orderStatus == 'IW'">
                <div class="custom-button" @click="endorse">退票</div>
                <!-- <div class="custom-button" @click="endorse">改期</div> -->
              </template>
              <div v-if="orderInfo.orderStatus == 'WP'" class="custom-button" @click="$toPay(orderInfo.serialNo)">支付</div>
            </div>
          </template>
        </OrderDetailContent>
      </div>
    </div>
  </div>
</template>

<script>
import MemberLeft from "@/components/MemberLeft";
import OrderDetailContent from "./components/OrderDetailContent.vue";
import wxCode from "@/assets/wxapp_code.jpg";
export default {
  name: "IntOrderDetail",
  components: { OrderDetailContent, MemberLeft  },

  methods: {
    endorse() {
      const h = this.$createElement;
      this.$msgbox({
        title: "请扫码进入湖南航空小程序进行改期/退票",
        message: h(
          "div",
          { style: { textAlign: "center" } },
          [ h("img", { attrs: { src: wxCode } }) ]
        ),
        showConfirmButton: false
      });
    },
  }
};
</script>

<style lang="less" scoped>
.order-detail-wrapper {
  .content-wrapper {
    width: 1200px;
    margin: 16px auto;
    display: flex;
    gap: 16px;
    .left-side {
      width: 240px;
      overflow: hidden;
    }
    .right-content {
      flex: 1;
    }
  }
}

.order-custom {
  width: fit-content;
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  .custom-button {
    width: 50px;
    background-color: #d70039;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    padding: 4px 8px;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
